module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "element element-non-bodymatter element-container-single element-type-titlepage title-page",
    attrs: {
      "epub:type": "titlepage",
      "id": "title-page"
    }
  }, [_c('div', {
    staticClass: "title-page-title-subtitle-block"
  }, [_c('h1', {
    staticClass: "title-page-title case-upper"
  }, [_vm._v("FEAR NO EVIL")]), _vm._v(" "), _c('h2', {
    staticClass: "title-page-subtitle case-upper"
  }, [_vm._v("CHRISTIAN ROMANTIC SUSPENSE")]), _vm._v(" "), _c('div', {
    staticClass: "title-page-series-info"
  }, [_c('p', {
    staticClass: "title-page-series-name case-upper"
  }, [_vm._v("THE LOST ARE FOUND")]), _vm._v(" "), _c('p', {
    staticClass: "title-page-series-position case-upper"
  }, [_vm._v("BOOK ONE")])]), _vm._v(" "), _c('div', {
    staticClass: "titlepage-ornament-block titlepage-ornament-aspect-wide"
  }, [_c('div', {
    staticClass: "titlepage-ornament-size-container"
  }, [_c('img', {
    staticClass: "titlepage-ornament-image",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "images/heading-swash-ornate-screen.png"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "title-page-contributor-block"
  }, [_c('div', {
    staticClass: "title-page-contributor-primary-block"
  }, [_c('h2', {
    staticClass: "title-page-contributor title-page-contributor-primary title-page-contributor-without-introduction"
  }, [_c('span', {
    staticClass: "title-page-contributor-name case-upper"
  }, [_vm._v("REBECCA HARTT")])])])]), _vm._v(" "), _c('div', {
    staticClass: "publisher-block"
  }, [_c('div', {
    staticClass: "title-page-publisher-logo-block title-page-publisher-logo-aspect-wide"
  }, [_c('div', {
    staticClass: "title-page-publisher-logo-size-container publisher-logo-width-1000-pad-207-1000"
  }, [_c('img', {
    staticClass: "title-page-publisher-logo-image",
    attrs: {
      "alt": "Rise UP Publications",
      "src": "images/riseup_logo_primary.png"
    }
  })])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6536f60e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/title-page.vue
// module id = 57
// module chunks = 0